var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginSenha(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0H22V22H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.795,13.58H19.35v3.667h1.833V13.58h1.833V11.747H13.795S13.79,12.593,13.795,13.58Z",
    transform: "translate(-2.85 -1.663)",
    fill: "#2e80c3",
    opacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.417,5a6.417,6.417,0,1,0,5.793,9.167h2.457v3.667h5.5V14.167H22v-5.5H12.21A6.422,6.422,0,0,0,6.417,5Zm13.75,7.333H18.333V16H16.5V12.333H10.945l-.211.614a4.583,4.583,0,1,1,0-3.062l.211.614h9.222ZM6.417,8.667a2.75,2.75,0,1,0,2.75,2.75A2.758,2.758,0,0,0,6.417,8.667Zm0,3.667a.917.917,0,1,1,.917-.917A.919.919,0,0,1,6.417,12.333Z",
    transform: "translate(0 -0.417)",
    fill: "#2e80c3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginSenha);
export default __webpack_public_path__ + "static/media/login_senha.fdcd5252034f135a4b481f6de21308cb.svg";
export { ForwardRef as ReactComponent };